import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

/**
 * Componente de pago incorrecto.
 */
@Component({
  selector: 'app-payment-ok',
  templateUrl: './payment-ko.component.html',
  styleUrls: ['./payment-ko.component.scss']
})
export class PaymentKoComponent implements OnInit {

  /**
   * Constructor.
   * @param activatedRoute
   */
  constructor(private activatedRoute: ActivatedRoute) {
    this.activatedRoute.queryParams.subscribe(params => {
  });
   }

   /**
    * Inicialización del componente.
    */
  ngOnInit() {
  }

}
